import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import { Border } from "Signups/FamilyRegistration/Shared/StyledComponents";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

import TempColorPicker from "UI/TempColorPicker/TempColorPicker";

import { colorIsLight, ensureLeadingHex } from "Utilities/Colors/colorUtils";


export default function AccentColorTemporary() {
  const {
    state: {
      familyRegistrationSettings: {
        accentColor: { selectedColor, colorScheme },
      },
    },
  } = useFamilyRegistrationContext();

  const [color, setColor] = useState(selectedColor || "#016099");
  const [show, setShow] = useState(false);
  const { updateSetting, saving, error, setError } = useUpdateSetting();

  const [gradient, setGradient] = useState(colorScheme);

  const {
    shouldDisableFamilyRegistrationSettings,
    shouldHideNonNetworkEnabledSettings,
  } = useFamilyRegistrationAdminPermissions();

  function saveColor() {
    const generatedGradient = gradient.map((c) =>
      ensureLeadingHex(c).toLowerCase()
    );
    updateSetting({
      setting: "accentColor",
      value: { color, colorScheme: generatedGradient },
    }).then((res) => {
      if (res === undefined) return;
      setShow(false);
    });
  }

  useEffect(() => {
    let tooLight = colorIsLight(color);
    if (tooLight) {
      setError({
        error:
          "Please select a darker color. Colors that are too light make things difficult to read.",
      });
    } else {
      setError(undefined);
    }
  }, [color, setError]);

  if (shouldHideNonNetworkEnabledSettings) return null;

  return (
    <Stack disabled={shouldDisableFamilyRegistrationSettings}>
      <Row>
        <PaintBrushIcon className="far fa-paint-brush" />
        <Border>
          <Content>
            <Text>Accent Color</Text>
            <TempColorPicker
              selectedColor={selectedColor}
              color={color}
              setColor={setColor}
              save={saveColor}
              disabled={saving}
              error={error}
              show={show}
              setShow={setShow}
              saving={saving}
              showGradientSelector={true}
              onSelectGradient={setGradient}
              initialGradient={colorScheme}
            />
          </Content>
        </Border>
      </Row>
    </Stack>
  );
}

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PaintBrushIcon = styled.div`
  font-size: 22px;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-left: -3px;
  flex-shrink: 0;
  margin-right: 9px;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 200px;

  transition: 0.2s;

  ${({ hovering }) =>
    hovering &&
    `
        transform: scale(1.02);
    `}

  ${({ active }) =>
    active &&
    `
        transform: scale(0.95);
    `} // transition: background-color 250ms;

    // &:hover {
    //     background-color: #daeaf5;
    // }
`;

const Text = styled.span`
  transition: 0.2s;

  // ${({ hovering }) =>
    hovering &&
    `
    //     transform: scale(1.45);
    // `}

  // &:active {
  //     transform: scale(0.95);
  // }
`;

const ColorPickerButton = styled.span`
  // display: flex;
  // align-items: center;
  // gap: 8px;
`;

const ColorSquare = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: relative;
  z-index: 1;
  border: 2px solid rgba(255, 255, 255, 0);
  box-sizing: border-box;
  transition: 0.2s;
  ${({ color }) => color && `background-color: #${color};`}
  ${({ first }) =>
    first &&
    `
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    `}
    ${({ last }) =>
    last &&
    `
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
    `}
    ${({ t }) =>
    t &&
    `
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    `}
    ${({ b }) =>
    b &&
    `
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    `}
    ${({ selected }) =>
    selected &&
    `
        transform: scale(1.25);
        //border: 2px solid rgba(0, 0, 0, 0.7);
        border: 2px solid rgba(255, 255, 255, 1);
        border-radius: 5px;
        box-shadow: rgb(0 0 0 / 50%) 0 0 3px;
        z-index: 10;
    `}
    ${({ hovering }) =>
    hovering &&
    `
        //transform: scale(1.45);
        border: 2px solid rgba(255, 255, 255, 1);
        border-radius: 5px;
        box-shadow: rgb(0 0 0 / 50%) 0 0 6px;
        z-index: 10;
    `}
    &:hover {
    transform: scale(1.45);
    border: 2px solid rgba(255, 255, 255, 1);
    border-radius: 5px;
    box-shadow: rgb(0 0 0 / 50%) 0 0 6px;
    z-index: 10;
  }
  &:active {
    ${({ buttonActive }) => !buttonActive && `transform: scale(1);`}
  }
  &:active div {
    ${({ buttonActive }) => !buttonActive && `transform: scale(1);`}
  }
`;